<!--仓库管理 出库-出库详情  -->
<template>
  <div>
    <el-row style="margin-top: 20px; width: 70%;" v-if="currentOrderFlag == 1">
      <el-col :span="10"><span class="title">订单编号</span>：{{ title[0] }}</el-col>
      <el-col :span="5"><span class="title">送货日期</span>：{{ title[1] }}</el-col>
      <el-col :span="9"><span class="title">客户</span>：{{ title[2] }}</el-col>
    </el-row>
    <el-row style="margin-top: 20px; width: 100%;" v-if="currentOrderFlag == 0">
      <el-col :span="12"><span class="title">订单编号</span>：{{ title[1] }}</el-col>
      <el-col :span="12"><span class="title">订单ID</span>：{{ title[0] }}</el-col>
    </el-row>
    <el-row style="margin-top: 20px; width: 100%;" v-if="currentOrderFlag == 0">
      <el-col :span="12"><span class="title">团餐公司</span>：{{ title[2] }}</el-col>
      <el-col :span="6"><span class="title">项目点</span>：{{ title[3] }}</el-col>
      <el-col :span="6"><span class="title">档口</span>：{{ title[4] }}</el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-button size="medium" @click="addData">新增</el-button>
      <el-button size="medium" @click="uploadFile">上传出库单</el-button>
    </el-row>
    <el-table ref="table" v-loading="loading" :data="listData" :span-method="objectSpanMethod" class="tableArea"
      style="width: 100%" border :cell-class-name="tableCellClassName" @cell-click="cellClick"
      :cell-style="setOutBackgroundColor">
      <el-table-column prop="ID" label="序号" width="50">
        <template slot-scope="scope">
          <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
            {{ scope.row.ID }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="NAME" label="名称">
        <template slot-scope="scope">
          <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
            {{ scope.row.NAME }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="TYPE_UNIT" label="单位">
        <template slot-scope="scope">
          <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
            {{ scope.row.TYPE_UNIT }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="NEED_COUNT" label="所需总数">
        <template slot-scope="scope">
          <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
            {{ scope.row.NEED_COUNT }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PRODUCT_COMMENT" label="备注">
        <template slot-scope="scope">
          <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
            {{ scope.row.PRODUCT_COMMENT }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="可出库产品">
        <el-table-column prop="WAREHOUSE_PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="NEW_TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_PRICE" label="单价"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
        <el-table-column label="保质期">
          <template slot-scope="scope">
            <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="INW_COUNT" label="库存数量"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
        <el-table-column prop="LACK_COUNT" label="出库数量" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.LACK_COUNT" :placeholder="scope.row.PLACE_LACK_COUNT" clearable
              @clear="clear(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="合计" width="100" align="center">
          <template slot-scope="scope">
            {{ totalObj[scope.row.ORDER_DETAIL_ID] }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="modify(scope.row)">添加出库产品</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加出库产品 -->
    <el-dialog title="添加出库产品" :visible.sync="editFormVisible" center width="1000px" @close="closeDialog"
      :close-on-click-modal="false">
      <el-row style="margin-top: 20px">
        <el-col>
          <el-form size="small" :inline="true" class="demo-form-inline" style="padding: 0; margin: 0"
            @submit.native.prevent>
            <el-form-item label="产品名称：">
              <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span>需出库产品：{{ addlist_row.NAME }}</span>
          <span>所需总数：{{ addlist_row.NEED_COUNT }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border style="width: 100%;margin-top: 20px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="库存" min-width="80"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="80"></el-table-column>
            <el-table-column label="数量" min-width="70">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.NEED_COUNT" placeholder="请输入" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="addProduct(ID, scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pagination_box" style="text-align: left; margin-top: 20px">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">完成</el-button>
      </div>
    </el-dialog>
    <!-- 周转筐信息模态框 -->
    <el-dialog title="周转筐信息" :visible.sync="turnoverInfoVisible" center width="400px" @close="closeTurnoverInfoDialog"
      :close-on-click-modal="false">
      <el-form size="small" :model="turnoverInfoForm" ref="turnoverInfoForm">
        <el-form-item label="客户：" :label-width="labelWidth">
          <span>{{ turnoverCusInfo.company }}</span>
        </el-form-item>
        <el-form-item label="项目点：" v-if="(currentOrderFlag == 0)" :label-width="labelWidth">
          <span>{{ turnoverCusInfo.project }}</span>
        </el-form-item>
        <div v-for="item in turnoverInfoForm.turnoverInfos" :key="item.key">
          <el-form-item label="周转筐：" :label-width="labelWidth">
            <el-select v-model="item.ID" placeholder="请选择周转筐" style="width: 100%;" filterable
              @change="turnoverChange(item)">
              <el-option v-for="item2 in turnoverList" :label="item2.NAME" :value="item2.BASKET_ID"
                :key="item2.BASKET_ID" :disabled="item2.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量：" :label-width="labelWidth">
            <el-input v-model.number="item.COUNT" type="number" placeholder="请输入数量" :min="1" style="width: 100%;">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="btn" @click="turnoverInfoForm.turnoverInfos.push({})"
            :disabled="disabledAdd">添加筐</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTurnoverInfoDialog">取消</el-button>
        <el-button size="small" @click="submitTurnoverInfo" :disabled="disabledSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 出库数量错误产品信息模态框 -->
    <el-dialog title="出库数量错误产品信息" :visible.sync="mistakeInfoVisible" center width="1400px"
      @close="() => { mistakeInfoVisible = false; mistakeList = [] }" :close-on-click-modal="false">
      <el-table :data="mistakeList" border>
        <el-table-column prop="WAREHOUSE_PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="NEW_TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="PRODUCT_PRICE" label="单价" width="150"></el-table-column>
        <el-table-column prop="BATCH" label="批次" width="250"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" width="110" v-if="WAREHOUSE_MODE == 2"></el-table-column>
        <el-table-column prop="LACK_COUNT" label="数量" width="110"></el-table-column>
        <el-table-column prop="REASON" label="出错原因" width="200"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="() => { mistakeInfoVisible = false; mistakeList = [] }">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="上传出库单" center :visible.sync="uploadFileDialog" width="500px" :close-on-click-modal="false">
      <el-form ref="uploadFileForm" :model="uploadFileForm" label-width="120px" label-suffix="：">
        <el-form-item label="出库单" prop="fileList">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload"
            :on-success="$util.handleUploadSuccess.bind(this, 'uploadFileForm', 'fileList')"
            :on-remove="$util.handleUploadRemove.bind(this, 'uploadFileForm', 'fileList')" :name="uploadFileForm.name"
            :limit="1" :file-list="uploadFileForm.fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadFileDialog = false">取 消</el-button>
        <el-button size="small" @click="submitUploadFile">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="4" :offset="20" style="margin-top: 24px">
        <el-button size="small" type="default" @click="openTurnoverInfoDialog" v-if="(currentOrderFlag == 0)">
          周转筐信息
        </el-button>
        <el-button size="small" type="default" :disabled="!allButton" @click="allSubmit">全部确认</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  stockOutDetailFun, setOutFontColor, stockOutAllFun, queryWarehouseFun,
} from 'api/warehouseManager';
import util from '@/assets/common/util';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      orderID: Number(sessionStorage.getItem('oreder_id')),
      noWareDate: [],
      noDetailVisible: false,
      name: '',
      pro_type: '',
      deliverId: '',
      spanArr: [],
      position: 0,
      positionSto: 0,
      listData: [],
      dialogVisible: false,
      form: {},
      outwareDate: [],
      total_count: 0,
      out_count: '',
      allButton: 1,
      loading: false,
      submitUpArr: [],
      spanStoArr: [],
      iwTagList: ['本产品', '可以拆箱为本产品', '可以合箱为本产品'],
      editFormVisible: false,
      searchForm: {},
      ADD_STATUS: 1,
      tableData: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      addDis: true,
      tmpArr: [],
      productID: '',
      productCount: '',
      ID: '',
      rowIndex: '',
      addlist_row: {},
      getSpanArr: [],
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      turnoverInfoVisible: false,
      turnoverInfoForm: {
        turnoverInfos: [{}],
      },
      turnoverList: [],
      turnoverCusInfo: JSON.parse(sessionStorage.getItem('turnoverCusInfo')),
      labelWidth: '80px',
      title: JSON.parse(sessionStorage.getItem('stockOutDetailTitle')),
      mistakeList: [],
      mistakeInfoVisible: false,
      uploadFileDialog: false,
      uploadFileForm: {
        name: 'tmp',
        fileList: [],
      },
      stockOutTcId: sessionStorage.getItem('stockOutTcId'),
    };
  },
  computed: {
    disabledAdd () {
      return this.turnoverInfoForm.turnoverInfos.length >= this.turnoverList.length;
    },
    disabledSubmit () {
      return Boolean(this.turnoverInfoForm.turnoverInfos.find((item) => !item.ID || !item.COUNT || item.COUNT < 1));
    },
    totalObj () {
      return this.listData.reduce((obj, x) => {
        if (x.ORDER_DETAIL_ID in obj) obj[x.ORDER_DETAIL_ID] += isNaN(x.LACK_COUNT) ? 0 : Number(x.LACK_COUNT);
        else obj[x.ORDER_DETAIL_ID] = Number(x.LACK_COUNT);
        return obj;
      }, {});
    },
  },
  inject: ['reload'],
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
  methods: {
    // 取得对应行的index
    tableCellClassName ({
      row, column, rowIndex, columnIndex,
    }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClick (row, column, cell, event) {
      this.rowIndex = row.index;
    },
    // 增加一条新的数据
    addProduct (id, row) {
      if (!row.NEED_COUNT || row.NEED_COUNT == '') {
        this.$message.show({ text: '请输入出库数量', type: 'warning' });
        return false;
      }
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数(后面可以跟.0000)
      const reg2 = /^\d+(\.0+)?$/;
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!reg1.test(row.NEED_COUNT)) {
          this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
          return false;
        }
      } else if (!reg2.test(row.NEED_COUNT)) {
        this.$message.show({ text: '请输入正整数出库数量', type: 'warning' });
        return false;
      }
      if (row.NEED_COUNT) {
        let tag = true;
        const data = [
          {
            ADDED: 0,
            BATCH: row.BATCH,
            ENOUGH_FLAG: 1,
            // EXPIRATION_DAY: Number(row.EXPIRATION_DAY),
            QGP: Number(row.QGP),
            QGP_TIME_TYPE: Number(row.QGP_TIME_TYPE),
            ID: id,
            INW_COUNT: Number(row.PRODUCT_COUNT),
            ORDER_DETAIL_ID: Number(this.addlist_row.ORDER_DETAIL_ID),
            LACK_COUNT: row.NEED_COUNT, // 出库数量
            WAREHOUSE_PRODUCT_NAME: row.PRODUCT_NAME,
            NEW_TYPE_UNIT: row.TYPE_UNIT,
            PLACE_LACK_COUNT: 0,
            PRODUCTION_DATE: row.PRODUCTION_DATE,
            WAREHOUSE_PRODUCT_CODE: row.PRODUCT_CODE,
            PRODUCT_PRICE: row.PRODUCT_PRICE,
            TYPE_UNIT: this.addlist_row.TYPE_UNIT,
            NAME: this.addlist_row.NAME,
            NEED_COUNT: this.addlist_row.NEED_COUNT, // 所需总量
            LOCATION_ID: row.LOCATION_ID,
          },
        ];
        for (let i = 0; i < this.listData.length; i++) {
          if (data[0].BATCH === this.listData[i].BATCH) {
            if (data[0].ID === this.listData[i].ID) {
              this.listData[i].LACK_COUNT = Number(this.listData[i].LACK_COUNT) + Number(data[0].LACK_COUNT);
              tag = false;
            }
          }
        }
        if (tag) {
          this.listData.splice(this.rowIndex, 0, data[0]);
        }
        this.spanArr = [];
        this.rowspan();
      }
    },
    // ----------------分页
    handleCurrentChange () {
      this.handleSearch();
    },
    handleSearch () {
      const params = {
        TC_ID: this.stockOutTcId,
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: 0,
        FLAG: 0,
      };
      this.loading = true;
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { NEED_COUNT: '' }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 添加出库产品按钮
    modify (row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.LACK_COUNT)) {
        this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
        return false;
      }
      this.addlist_row = row;
      this.ID = row.ID;
      this.editFormVisible = true;
    },
    $_setFontColor (number) {
      return setOutFontColor(Number(number));
    },
    setOutBackgroundColor ({
      row, column, rowIndex, columnIndex,
    }) {
      const indexArry = this.WAREHOUSE_MODE ? [5, 6, 7, 8, 9, 10, 11, 12] : [5, 6, 7, 8, 9, 10, 11];
      if (indexArry.includes(columnIndex)) {
        if (row.LACK_COUNT && row.ORDER_REAL_PRICE < row.PRODUCT_PRICE) {
          return { backgroundColor: '#FDE2E2' };
        }
      }
      return {};
    },
    // 新增按钮
    addData () {
      sessionStorage.setItem('deliverId', this.deliverId);
      this.$router.push({ name: 'ckaddProduct' });
    },
    // 页面加载时请求的数据
    queryData () {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('oreder_id')),
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      stockOutDetailFun(params).then((result) => {
        this.listData = result.map((item) => ({ ...item, NEW_TYPE_UNIT: item.TYPE_UNIT, PLACE_LACK_COUNT: item.LACK_COUNT }));
        this.rowspan();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------------------全部确认
    allSubmit () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          for (let i = 0; i < this.listData.length; i++) {
            if (this.listData[i].LACK_COUNT === '') {
              this.mistakeList.push({ ...this.listData[i], REASON: '出库数量不得为空' });
              continue;
            }
            if (this.listData[i].LACK_COUNT > this.listData[i].INW_COUNT) {
              this.mistakeList.push({ ...this.listData[i], REASON: '出库数量不能大于库存数量' });
              continue;
            }
            if (util.JudgmentUnit(this.listData[i].NEW_TYPE_UNIT)) {
              if (!validation.数量正数0验证(this.listData[i].LACK_COUNT)) {
                this.mistakeList.push({ ...this.listData[i], REASON: '出库数量必须为正数' });
                continue;
              }
            } else if (!validation.数量整数正数0验证(this.listData[i].LACK_COUNT)) {
              this.mistakeList.push({ ...this.listData[i], REASON: '出库数量必须为正整数' });
              continue;
            }
          }
          if (this.mistakeList.length) {
            document.body.style.cursor = 'default';
            this.mistakeInfoVisible = true;
            return false;
          }
          const tmpArr = this.listData.map((item, index) => ({
            BATCH: item.BATCH,
            DELIVER_COUNT: Number(item.LACK_COUNT),
            ORDER_DETAIL_ID: Number(item.ORDER_DETAIL_ID),
            LOCATION_ID: Number(item.LOCATION_ID) ? Number(item.LOCATION_ID) : 0,
            PRODUCT_CODE: item.WAREHOUSE_PRODUCT_CODE,
          }));
          const submitArr = tmpArr.filter((item) => item.DELIVER_COUNT !== 0);
          const params = {
            FOR_SMP: 1,
            ORDER_ID: Number(sessionStorage.getItem('oreder_id')),
            PRODUCT_ARRAY: submitArr,
            WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          const stockOutFileDict = JSON.parse(sessionStorage.getItem('stockOutFileDict')) || {};
          if (stockOutFileDict[this.orderID] && stockOutFileDict[this.orderID].length) params.FILE_NAME = stockOutFileDict[this.orderID][0].response.file_name;
          stockOutAllFun(params).then((result) => {
            if (params.FILE_NAME) {
              delete stockOutFileDict[this.orderID];
              sessionStorage.setItem('stockOutFileDict', JSON.stringify(stockOutFileDict));
            }
            this.$message.show({ text: '出库成功', type: 'success' });
            this.$router.push({ name: 'stockOut' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // --------------------------行
    rowspan () {
      this.listData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.listData[index].ID === this.listData[index - 1].ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod ({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }

      if (this.WAREHOUSE_MODE == 2 ? columnIndex === 14 : columnIndex === 13) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (this.WAREHOUSE_MODE == 2 ? columnIndex === 15 : columnIndex === 14) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    // 关闭模态框
    closeDialog () {
      this.editFormVisible = false;
      this.searchForm = {};
      this.tableData = [];
      this.totalCount = 0;
    },
    clear (row) {
      this.$set(row, 'LACK_COUNT', 0);
    },
    closeTurnoverInfoDialog () {
      this.turnoverInfoVisible = false;
      this.turnoverInfoForm.turnoverInfos = [{}];
    },
    submitTurnoverInfo () {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 23,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: this.turnoverCusInfo.projectId,
        BASKET_LIST: this.turnoverInfoForm.turnoverInfos,
        TYPE: 1,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '记录添加成功', type: 'success' });
        this.closeTurnoverInfoDialog();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 拉取周转筐数据
    queryTurnover () {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result) {
          this.turnoverList = result;
        } else {
          this.turnoverList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    openTurnoverInfoDialog () {
      this.queryTurnover();
      this.turnoverInfoVisible = true;
    },
    turnoverChange (item1) {
      const temp = this.turnoverList.find((item2) => item1.ID == item2.BASKET_ID);
      temp.disabled = !temp.disabled;
    },
    uploadFile () {
      const stockOutFileDict = JSON.parse(sessionStorage.getItem('stockOutFileDict')) || {};
      if (!this.uploadFileForm.fileList.length && this.orderID in stockOutFileDict) this.uploadFileForm.fileList = stockOutFileDict[this.orderID] || [];
      this.uploadFileDialog = true;
    },
    closeUploadFile () {
      this.$refs.upload.clearFiles();
      this.$refs.uploadFileForm.resetFields();
      this.uploadFileDialog = false;
    },
    submitUploadFile () {
      this.$refs.uploadFileForm.validate((valid) => {
        if (valid) {
          const stockOutFileDict = JSON.parse(sessionStorage.getItem('stockOutFileDict')) || {};
          stockOutFileDict[this.orderID] = this.uploadFileForm.fileList;
          sessionStorage.setItem('stockOutFileDict', JSON.stringify(stockOutFileDict));
          this.closeUploadFile();
          this.$message.show({ text: '上传成功', type: 'success' });
        }
      });
    },
  },
};
</script>
<style scoped>
.el-table .warning-row {
  background: pink;
}

.tableArea {
  margin-top: 20px;
}

.title {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockOutDetail.vue